export const OrderIdMaxDigits: number = 10
